var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-inner" }, [
      _c("div", { staticClass: "title-container" }, [
        _c("span", { staticClass: "icon" }, [_vm._t("icon")], 2),
        _vm._v(" "),
        _c("span", { staticClass: "title" }, [_vm._t("title")], 2),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-container" }, [_vm._t("default")], 2),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "more-infos" }, [_vm._t("moreInfos")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }